import React, { useState } from "react";
import { caseStudiesProcess } from "./CaseStudyData";
import { Col, Container, Row } from "react-bootstrap";
import MajorClient from "../Home/Components/MajorClient";
import Testimonials from "../Home/Components/Testimonials";
import { PiArrowBendDownRightBold } from "react-icons/pi";
import Image1 from "../../Images/CaseStudies/Realtime.webp";
import { IoMdStar } from "react-icons/io";
import client from "../../Images/CaseStudies/client-benifit.webp";
import Image6 from "../../Images/CaseStudies/Draygo.webp";

const DraygoLogistics = () => {
  const [tabName, setTabName] = useState("Business Needs");

  return (
    <div>
      <div className="case_study_details case_study">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11} className="case_content text-center">
              <h1>
                <span> Draygo Logistics Platform</span>
              </h1>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col lg={12}>
            <div className="industrial">
              <img src={Image6} alt={Image6} className="img-fluid" />
              <div className="industrial_content">
                <p>
                 Draygo is a cutting-edge logistics platform aimed at transforming how brokers, shippers, carriers, drivers, and dispatchers collaborate and oversee shipments. It offers a unified system that facilitates real-time tracking, flexible payment options (including cryptocurrency), multi-country container management, and smooth communication with integrated chat support. By streamlining connections between all key players, Draygo boosts efficiency across the logistics sector. With its powerful mobile and web applications, the platform guarantees top-tier performance in the logistics industry.
                </p>
                <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                    <h4>Industry</h4>
                    <p>
                      <b>Logistics & Transportation</b>
                    </p>
                  </div>
                  <div>
                    <h4>Country</h4>
                    <p>
                      <b> United States (Global Operations Supported)</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <hr className="m-0" />
      <div className="case_img_box">
        <Container>
          <div className="case_box position-relative">
            <img src={Image6} alt={Image6} />
          </div>
        </Container>
      </div>

      <hr className="m-0" />

      <Container>
        <Row className="case_content_box">
          <Col lg={12} className="px-3">
            <div className="case_content p-3">
              <h2 className="case_heading">About</h2>
              <p>
                Draygo is an innovative logistics platform designed to
                revolutionise the way brokers, shippers, carriers, drivers, and
                dispatchers coordinate and manage shipments. By providing an
                integrated solution for real-time tracking, payment flexibility
                (including cryptocurrency), multi-country container management,
                and seamless communication through integrated chat support,
                Draygo enhances efficiency across the entire logistics
                ecosystem. The platform seamlessly connects key stakeholders and
                provides robust mobile and web applications, ensuring optimal
                performance in the logistics industry.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className=" my-5">
        <div className="process px-3">
          <h2 className="case_heading">Process</h2>
          <Row className="mt-4 justify-content-center">
            {caseStudiesProcess.map((step, index) => (
              <Col lg={3} md={4} sm={6} key={index} className="mb-3">
                <div className="card">
                  <span>{step.step}</span>
                  {step.icon}
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <Container className=" my-5">
        <Row className="mt-5 client_benefits align-items-center">
          <Col md={6}>
            <h2 className="case_heading">Client Benefits</h2>
            <ul className="mt-4 p-0">
              <li className="d-flex align-items-start gap-2">
                <IoMdStar fontSize={`40px`} />
                Provides brokers, shippers, and dispatchers with accurate,
                real-time tracking of shipments and drivers, ensuring
                transparency and proactive problem-solving.
              </li>
              <li classNa me="d-flex align-items-start gap-2">
                <IoMdStar fontSize={`40px`} />
                Draygo supports multiple payment methods, including
                cryptocurrency, allowing for fast and secure transactions,
                particularly for international shipments.
              </li>
              <li className="d-flex align-items-start gap-2">
                <IoMdStar />
                The platform supports cross-border container management,
                simplifying logistics for international shipments and reducing
                complexity in global shipping operations.
              </li>
              <li className="d-flex align-items-start gap-2">
                <IoMdStar />
                The platform offers tailored mobile apps for drivers, brokers,
                and shippers, and a comprehensive web app for overall tracking
                and logistics management, providing flexibility for different
                stakeholders.
              </li>
              <li className="d-flex align-items-start gap-2">
                <IoMdStar />
                Draygo optimises communication and coordination between all
                parties involved in the logistics process, reducing manual work,
                errors, and delays.
              </li>
              <li className="d-flex align-items-start gap-2">
                <IoMdStar />
                The platform can scale to support logistics operations of
                varying sizes, from small businesses to multinational
                corporations, with the ability to handle large volumes of
                shipments and users.
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <img src={client} alt={client} className="img-fluid" />
          </Col>
        </Row>
        <hr className="my-5" />

        <div className="challenges my-5">
          <h2 className="case_heading">Challenges </h2>
          <Row className="mt-4 justify-content-center">
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 1</span>
                <h5>Cross-Border Logistics Management</h5>

                <p className="mb-1">
                  <b>Challenge</b> : Managing logistics across multiple
                  countries, handling different regulations, tolls, state
                  permits, and customs requirements.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Draygo integrates cross-border logistics
                  management, providing brokers and shippers with visibility
                  into customs regulations, toll costs, and required state
                  permits.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom border-right">
              <div className="card position-relative">
                <span> 2</span>
                <h5>Real-Time Driver and Shipment Tracking</h5>

                <p className="mb-1">
                  <b>Challenge</b> : Ensuring real-time visibility of shipments
                  and drivers, especially across long distances and multiple
                  stakeholders.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: The platform uses GPS and IoT technology to
                  provide real-time tracking and location updates for both
                  drivers and shipments, allowing all stakeholders to monitor
                  progress effectively.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 3</span>
                <h5>Payment Flexibility in International Shipping</h5>

                <p className="mb-1">
                  <b>Challenge</b>: Managing payment systems that are fast,
                  secure, and adaptable for international transactions.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Draygo supports cryptocurrency payments,
                  offering faster and more secure transactions across borders,
                  reducing friction in cross-border logistics.
                </p>
              </div>
            </Col>
            <Col lg={4} className="border_bottom">
              <div className="card position-relative">
                <span> 4</span>
                <h5>Driver and Carrier Coordination</h5>

                <p className="mb-1">
                  <b>Challenge</b> : Coordinating between drivers, carriers,
                  brokers, and dispatchers to ensure timely and accurate job
                  assignments.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Draygo offers a real-time mobile app
                  notification system for drivers, enabling job acceptance and
                  tracking, and providing dispatchers and brokers with seamless
                  updates on job
                </p>
              </div>
            </Col>
            <Col lg={4} className="border-left border_bottom">
              <div className="card position-relative">
                <span> 5</span>
                <h5> Instant Communication</h5>

                <p className="mb-1">
                  <b>Challenge</b>: Ensuring effective communication between
                  drivers, brokers, and shippers in real time, especially when
                  issues arise or clarification is needed.
                </p>

                <p className="mb-1">
                  <b>Solution</b>: Draygo introduces integrated chat features
                  for direct communication between drivers, brokers, and
                  shippers. This reduces the need for phone calls or emails and
                  allows for instant problem-solving.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="process_tab_box">
          <Row className="justify-content-center">
            <Col lg={10} className="process_tab_list">
              <ul className="p-0">
                <li
                  onClick={() => setTabName("Business Needs")}
                  className={`${tabName === "Business Needs" ? "active" : ""}`}
                >
                  Business Needs
                </li>
                <li
                  onClick={() => setTabName("Objectives Achieved")}
                  className={`${
                    tabName === "Objectives Achieved" ? "active" : ""
                  }`}
                >
                  Objectives Achieved
                </li>
                <li
                  onClick={() => setTabName("Technologies Used")}
                  className={`${
                    tabName === "Technologies Used" ? "active" : ""
                  }`}
                >
                  Technologies Used
                </li>
              </ul>
            </Col>
            <Col lg={10} className="mt-4">
              {tabName === "Business Needs" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Real-Time Logistics Management
                        </h6>
                        <p>
                          The business required a solution that provided
                          end-to-end visibility of shipments and drivers across
                          all stages of the journey, enabling brokers, shippers,
                          and dispatchers to monitor and manage operations in
                          real-time.
                        </p>
                      </li>
                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Flexible Payment System
                        </h6>
                        <p>
                          There was a need for a secure and efficient payment
                          system that could support various payment methods,
                          including cryptocurrency, to streamline
                          transactions—especially in international
                          shipping—where traditional banking systems can cause
                          delays and added complexity.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Scalable and Secure System
                        </h6>
                        <p>
                          The logistics platform had to be scalable to handle
                          operations of all sizes, from small local shippers to
                          large international carriers, while ensuring security
                          and data protection across all user interactions.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                          Cross-Border Coordination
                        </h6>
                        <p>
                          The business required a solution capable of managing
                          logistics across multiple countries, ensuring
                          compliance with local regulations, customs, and
                          international shipping standards, without causing
                          delays or complications in cross-border
                          transportation.
                        </p>
                      </li>

                      <li>
                        <h6>
                          <PiArrowBendDownRightBold />
                           Communication and Coordination
                        </h6>
                        <p>
                          There was a need for a system that facilitated
                          seamless communication between all logistics
                          stakeholders—brokers, shippers, carriers, drivers, and
                          dispatchers—ensuring smooth collaboration and reduced
                          operational delays.
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Objectives Achieved" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-0">
                          <b>
                            Complete Visibility of Shipments and Driver
                            Locations
                          </b>
                        </p>
                        <p className="p-0">
                          Draygo provides real-time tracking of both shipments
                          and drivers, improving decision-making by offering
                          visibility into the current status of every operation.
                          This transparency enhances overall operational
                          efficiency, ensuring that issues are addressed before
                          they impact the supply chain.
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>
                            Faster Transactions with Flexible Payment Options
                          </b>
                        </p>
                        <p className="p-0">
                          The system offers multiple payment methods, including
                          cryptocurrency, which speeds up payments and
                          eliminates the delays associated with traditional
                          banking. This feature has been particularly beneficial
                          for international shipping, where cross-border
                          payments can be slow and expensive.
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Scalability and Cloud Security</b>
                        </p>
                        <p className="p-0">
                          The platform has been built with a scalable
                          architecture, enabling it to support both small-scale
                          and large-scale logistics operations. It is backed by
                          secure cloud infrastructure, ensuring data integrity,
                          reliability, and high availability for users across
                          different levels of operation
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Seamless International Logistics Management</b>
                        </p>
                        <p className="p-0">
                          Draygo enables cross-border logistics coordination by
                          offering tools that support multi-country shipping and
                          ensure compliance with local customs, state permits,
                          and regulations. This has streamlined global
                          operations and eliminated the complexity of managing
                          international logistics
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Enhanced Collaboration and Efficiency</b>
                        </p>
                        <p className="p-0">
                          By offering real-time updates and communication
                          channels for brokers, shippers, drivers, carriers, and
                          dispatchers, Draygo optimises collaboration and
                          coordination. This ensures that all stakeholders are
                          aligned, reducing delays and improving the efficiency
                          of logistics operations
                        </p>
                      </li>

                      <li>
                        <p className="p-0 mb-0">
                          <b>Instant Communication via Integrated Chat</b>
                        </p>
                        <p className="p-0">
                          Draygo’s integrated chat system allows drivers,
                          brokers, and shippers to communicate in real time
                          without relying on external apps or phone calls. This
                          chat feature fosters better collaboration,
                          problem-solving, and quick decision-making during
                          critical operations, enhancing the overall user
                          experience.
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}

              {tabName === "Technologies Used" && (
                <div className="tab_content_box">
                  <div className="box">
                    <ol>
                      <li>
                        <p className="p-0 mb-2 mt-0">
                          Laravel (Backend Framework){" "}
                        </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">MySQL (Database)</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">
                          Livewire (Frontend Framework)
                        </p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">Blockchain</p>
                      </li>
                      <li>
                        <p className="p-0 mb-2 mt-0">GPS & Geolocation</p>
                      </li>
                    </ol>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <MajorClient />
      <Testimonials />
      {/* <ContactForm /> */}
    </div>
  );
};

export default DraygoLogistics;
